import { ProColumns } from '@ant-design/pro-components';
import { Tooltip as AntdTooltip } from 'antd';
import moment from 'moment';
import { LsxDangThucHienModel } from 'services/report_services';
import { formatNumber } from 'utils/formatHelper';

// table 1
export const columnsTable1: ProColumns[] = [
  // khách hàng
  { title: 'Khách hàng', dataIndex: 'khachHang', width: 80 },
  // Loại LSX
  {
    title: 'Loại LSX',
    dataIndex: 'loaiLSX',
    width: 35,
  },
  // LSX đang thực hiện
  {
    title: 'LSX đang TH',
    dataIndex: 'lsxDangThucHien',
    width: 40,
    render: (text) => {
      return {
        props: {
          style: {
            fontWeight: 'bold',
          },
        },
        children: text,
      };
    },
  },

  // TP/BTP
  {
    title: 'TP/BTP',
    dataIndex: 'tpbtp',
    width: 50,
  },
  // Ngày hàng in về
  {
    title: 'Ngày hàng in về',
    width: 60,
    dataIndex: 'ngayHangInVe',
    render(text, record) {
      return <>{record.ngayHangInVe ? moment(record.ngayHangInVe).format('DD/MM/YYYY HH:mm') : '-'}</>;
    },
    onCell: (_, index) => ({
      className: 'text-center',
    }),
  },
  // Số SP/Tờ/Công đoạn
  {
    title: 'Số SP/Tờ/CĐ',
    width: 30,
    dataIndex: 'soSpToCongDoan',
    render: (text) => {
      return {
        props: {
          style: {
            textAlign: 'right',
          },
        },
        children: text,
      };
    },
  },
  // Số lượng phát lệnh
  {
    title: 'SL phát lệnh',
    width: 35,
    dataIndex: 'slspTheoLSX',
    render: (text) => {
      return {
        props: {
          style: {
            textAlign: 'right',
          },
        },

        children: <>{formatNumber(Number(text), 0)}</>,
      };
    },
  },
  // Số lượng tờ (SP) qui đổi
  {
    title: 'SL tờ (SP) qui đổi',
    width: 40,
    dataIndex: 'slToSPQuyDoi',
    render: (text) => {
      return {
        props: {
          style: {
            textAlign: 'right',
          },
        },
        children: <>{formatNumber(Number(text), 0)}</>,
      };
    },
  },
  // SL đã ghi nhận
  {
    title: 'SL đã ghi nhận',
    width: 35,
    dataIndex: 'slDaGhiNhan',
    render: (text) => {
      return {
        props: {
          style: {
            textAlign: 'right',
          },
        },
        children: <>{formatNumber(Number(text), 0)}</>,
      };
    },
  },
  // ĐVT
  {
    title: 'ĐVT',
    width: 20,
    dataIndex: 'dvt',
  },
  // Thời gian giao hàng
  {
    title: 'TG giao hàng',
    width: 80,
    dataIndex: 'thoiGianGiaoHang',
    render(_, record: LsxDangThucHienModel) {
      return {
        props: {
          style: {
            textAlign: 'center',
          },
        },
        children: <>{record.thoiGianGiaoHang ? moment(record.thoiGianGiaoHang).format('DD/MM/YYYY HH:mm') : '-'}</>,
      };
    },
  },
  // Hướng dẫn sản xuất
  {
    title: 'Hướng dẫn SX',
    width: 145,
    dataIndex: 'hdsx',
    className: '!py-1',
  },
  // NVL sử dụng
  {
    title: 'NVL sử dụng',
    width: 95,
    dataIndex: 'nvlSuDung',
    className: '!py-1',
  },
];

// table head of drag table
export const columns: ProColumns[] = [
  {
    title: 'STT',
    width: 20,
    dataIndex: 'stt',
    fixed: 'left',
    className: 'text-center ',
    align: 'center',
  },
  {
    title: 'Khách hàng',
    width: 100,
    dataIndex: 'khachHang',
    className: 'text-center ',
  },
  {
    title: 'LSX',
    width: 40,
    dataIndex: 'lsx',
    className: '',
    render: (text) => {
      return {
        props: {
          style: {
            fontWeight: 'bold',
          },
        },
        children: text,
      };
    },
  },
  {
    title: 'TP/BTP',
    dataIndex: 'tpbtp',
    width: 110,
    render: (text, record) => {
      return <AntdTooltip title={text}>{text}</AntdTooltip>;
    },
  },
  {
    title: 'SL phát lệnh',
    width: 40,
    dataIndex: 'slPhatLenh',
    className: 'text-right',
    render: (text) => {
      return formatNumber(Number(text), 0);
    },
  },
  {
    title: 'ĐVT',
    width: 20,
    dataIndex: 'dvt',
    className: 'text-right',
  },
  {
    title: 'Thứ tự công đoạn',
    width: 35,
    dataIndex: 'thuTuCongDoan',
    className: 'text-right',
  },
  {
    title: 'Công đoạn',
    dataIndex: 'congDoan',
    width: 100,
  },
];
